module.exports = __webpack_public_path__ + "img/lector_de_codigo_de_barras_1d_2d.e0a90ca7.jpg";